import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Overlay from '../../../Componentes/Overlay';
import SideMenu from '../../../Componentes/SideMenu';
import SideMenuBtn from '../../../Componentes/SideMenuBtn';
import SortableTable from '../../../Componentes/Utils/SortableTable';
import { useModal } from '../../../contexts/ModalContext';
import ModalAddChecklist from './ModalAddChecklist';
import ModalChecklistTipos from './ModalChecklistTipos';
import ModalDeleteChecklist from './ModalDeleteChecklist';
import styled, { keyframes } from 'styled-components';

import { formatarData } from "../../../Funcoes/FormatarData"
import { useNavigate } from 'react-router-dom';
import GenericHeader from '../../../Componentes/GenericHeader';
import Filters from '../../../Componentes/Utils/Filters';
import FilterContainer from '../../../Componentes/Utils/FilterContainer';
import Stats from '../../../Componentes/Utils/Stats';
import Modal from '../../../Componentes/Utils/Modal';
import { VerifyPermission } from '../../../Funcoes/VerifyPermission';
import { AuthContext } from '../../../Auth/AuthProvider';
import useApi from '../../../hooks/useApi';
import { VscFilePdf } from "react-icons/vsc";
import { LuLoaderCircle, LuTrash2 } from "react-icons/lu";
import { saveAs } from 'file-saver';

const MOBILE_QUERY = '(max-width: 768px)';

const spin = keyframes`
    from{ transform: rotate( 0deg ) }
    to{ transform: rotate( 360deg ) }
`
const IconeContainer = styled.div`
    width: 40px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const IconePDF = styled(VscFilePdf)`
    margin: auto;
    cursor: pointer;
`
const IconeLixeira = styled(LuTrash2)`
    margin: auto;
    cursor: pointer;
    color: #DC2625;
`
const IconeLoad = styled(LuLoaderCircle)`
    margin: auto;
    animation: ${spin} 1s linear infinite;
`
const conformidadeColor = (percent) => {
    if (percent >= 75) return "#1f8500";
    if (percent >= 50) return "#bb6c05";
    return "#bb0505";
};
const TableArea = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
const ContainerId = styled.div`
    width: 60px;
    height: 35px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const ContainerStats = styled.div`
    margin: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 3px;
    p{
        margin: 0;
    }
`
const StatsWrapper = styled.div`
    & > div {
        border-radius: 12px;
        height: 100%;
    }
    @media (max-width: 768px) {
        width: 100%;
        & > div {
            width: 100%;
            box-sizing: border-box;
            padding: 10px;
        }
    }
`
const MobileFiltersStack = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const Content = () => {

    const { user } = useContext(AuthContext);
    const api = useApi();

    const { openModal, closeModal, isModalOpen } = useModal();
    const navigate = useNavigate();

    const closeSideBar = () => {

        closeModal();

    }

    const openNewChecklist = () => {

        closeModal();
        openModal("addChecklistModal");

    }

    const openChecklistTipos = () => {
        closeModal();
        openModal('tiposCheckListModal')
    }

    const openMetas = () => {
        closeModal();
        navigate('./metas');
    }

    const openNaoConformidades = () => {
        closeModal();
        navigate('./nao-conformidades')
    }

    const [loading, setLoading] = useState(true);
    const [checklists, setChecklists] = useState([]);
    const [checklistsFilter, setChecklistsFilter] = useState([]);

    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia(MOBILE_QUERY).matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;

        const mql = window.matchMedia(MOBILE_QUERY);
        const handleChange = (e) => setIsMobile(e.matches);

        setIsMobile(mql.matches);

        if (mql.addEventListener) {
            mql.addEventListener('change', handleChange);
            return () => mql.removeEventListener('change', handleChange);
        } else {
            mql.addListener(handleChange);
            return () => mql.removeListener(handleChange);
        }
    }, []);

    useEffect(() => {

        if (!isMobile && isModalOpen('checklistFiltersMobile')) {
            closeModal();
        }

    }, [isMobile, isModalOpen, closeModal]);

    const fetchChecklist = async () => {

        setLoading(true);

        try {

            const { data } = await api.get("/Painel/API/Checklist/GetChecklists/");
            console.log(data);
            setChecklists(data);
            setChecklistsFilter(data);

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {
        fetchChecklist();
    }, [])

    const listaTipos = useMemo(() => [...new Set(checklists.map((obj) => obj.tipo))].sort(), [checklists]);
    const listaModelos = useMemo(() => [...new Set(checklists.map((obj) => obj.modelo))].sort(), [checklists]);
    const listaEquipamentos = useMemo(() => [...new Set(checklists.map((obj) => obj.equipamento))].sort(), [checklists]);
    const listaCC = useMemo(() => [...new Set(checklists.map((obj) => obj.centro_custo))].sort(), [checklists]);
    const listaContrato = useMemo(() => [...new Set(checklists.map((obj) => obj.contrato))].sort(), [checklists]);
    const listaEquipes = useMemo(() => [...new Set(checklists.map((obj) => obj.equipe))].sort(), [checklists]);
    const listaUsuarios = useMemo(() => [...new Set(checklists.map((obj) => obj.usuario))].sort(), [checklists]);

    const [tipoFiltered, setTipoFiltered] = useState([]);
    const [modeloFiltered, setModeloFiltered] = useState([]);
    const [equipamentoFiltered, setEquipamentoFiltered] = useState([]);
    const [centroCustoFiltered, setCentroCustoFiltered] = useState([]);
    const [contratoFiltered, setContratoFiltered] = useState([]);
    const [equipeFiltered, setEquipeFiltered] = useState([]);
    const [statusFiltered, setStatusFiltered] = useState([]);
    const [usuarioFiltered, setUsuarioFiltered] = useState([]);
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');

    const handleFilter = useCallback(() => {
        setChecklistsFilter(
            checklists.filter((item) => {
                const tipo = !tipoFiltered.length || tipoFiltered.some(obj => (item.tipo || '').includes(obj.value));
                const modelo = !modeloFiltered.length || modeloFiltered.some(obj => (item.modelo || '').includes(obj.value));
                const equipamento = !equipamentoFiltered.length || equipamentoFiltered.some(obj => (item.equipamento || '').includes(obj.value));
                const obra = !centroCustoFiltered.length || centroCustoFiltered.some(obj => (item.centro_custo || '').includes(obj.value));
                const contrato = !contratoFiltered.length || contratoFiltered.some(obj => (item.contrato || '').includes(obj.value));
                const equipe = !equipeFiltered.length || equipeFiltered.some(obj => (item.equipe || '').includes(obj.value));

                const statusValue = item.qtd_preenchidos < item.qtd_itens
                    ? "EM ANDAMENTO"
                    : "FINALIZADO"

                const status = !statusFiltered.length
                    || statusFiltered.some(obj => statusValue.includes(obj.value));

                const usuario = !usuarioFiltered.length || usuarioFiltered.some(obj => (item.usuario || '').includes(obj.value));
                const dataIniOk = !dataInicial || (item.data && new Date(item.data) >= new Date(dataInicial));
                const dataFimOk = !dataFinal || (item.data && new Date(item.data) <= new Date(dataFinal));

                return tipo && modelo && equipamento && obra && contrato && equipe && status && usuario && dataIniOk && dataFimOk;
            })
        )
    }, [checklists, tipoFiltered, modeloFiltered, equipamentoFiltered, centroCustoFiltered, contratoFiltered, equipeFiltered, statusFiltered, usuarioFiltered, dataInicial, dataFinal]);

    useEffect(() => {

        handleFilter();

    }, [handleFilter]);

    const somaPreenchidos = checklistsFilter.reduce((acc, item) => acc + item.qtd_preenchidos, 0) ?? 0;

    const somaTotalItens = checklistsFilter?.reduce((acc, item) => acc + item.qtd_itens, 0) ?? 0;
    const totalConformes = checklistsFilter.reduce((acc, item) => acc + item.qtd_conforme, 0) ?? 0;
    const totalNaoConformes = checklistsFilter.reduce((acc, item) => acc + item.qtd_ncs, 0) ?? 0;

    const totalPercent = somaPreenchidos > 0 ? (totalConformes / somaTotalItens) * 100 : 0;
    const ncPercent = (totalNaoConformes / somaTotalItens) * 100;

    const [loadingIds, setLoadingIds] = useState([]);
    const [linhas, setLinhas] = useState(100);
    const [checklistDelete, setChecklistDelete] = useState(null);
    const tabelaRef = useRef(null);

    const canDeleteChecklist = useMemo(
        () => VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'apagar' }),
        [user]
    );

    const handleClick = useCallback(async (id) => {
        setLoadingIds((prev) => [...prev, id]);

        try {

            const { data } = await api.post(
                '/Painel/API/Checklist/GeneratePdfChecklists/',
                { id: id },
                {
                    responseType: "blob",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const pdfBlob = new Blob([data], { type: "application/pdf" });
            saveAs(pdfBlob, `checklist-${id}.pdf`);

        } catch (e) {

            console.error(e);

        } finally {

            setLoadingIds((prev) => prev.filter((loadingId) => loadingId !== id));

        }

    }, [api]);

    useEffect(() => {
        setLinhas(100);
    }, [checklistsFilter]);

    useEffect(() => {
        const element = tabelaRef.current;
        if (!element) return;

        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = element;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setLinhas((prev) => prev + 100);
            }
        };

        element.addEventListener("scroll", handleScroll);
        return () => element.removeEventListener("scroll", handleScroll);
    }, [api]);

    const columns = useMemo(
        () => [
            {
                id: "id",
                header: "ID",
                accessor: (r) => r.id,
                align: "center",
                sortValue: (r) => Number(r.id) || 0,
                render: (v) => <ContainerId>{v}</ContainerId>,
            },
            { id: "tipo", header: "TIPO", accessor: (r) => r.tipo },
            {
                id: "modelo",
                header: "MODELO",
                accessor: (r) => r.modelo,
                render: (v) => (v ? v : "-"),
            },
            {
                id: "equipamento",
                header: "EQUIPAMENTO",
                accessor: (r) => r.equipamento,
                render: (v) => (v ? v : "-"),
            },
            {
                id: "data",
                header: "DATA",
                accessor: (r) => r.data,
                align: "center",
                sortValue: (r) => (r.data ? new Date(r.data).getTime() : null),
                render: (v) => formatarData(v),
            },
            { id: "centro_custo", header: "CENTRO CUSTO", accessor: (r) => r.centro_custo },
            { id: "contrato", header: "CONTRATO", accessor: (r) => r.contrato },
            { id: "area", header: "ÁREA", accessor: (r) => r.area },
            { id: "nome_audit", header: "AUDITADO", accessor: (r) => r.nome_audit },
            { id: "lider_nome", header: "LÍDER", accessor: (r) => r.lider_nome },
            { id: "equipe", header: "EQUIPE", accessor: (r) => r.equipe },
            { id: "usuario", header: "USUÁRIO", accessor: (r) => r.usuario },
            {
                id: "preenchidos",
                header: "PREENCHIDOS",
                accessor: (r) => `${r.qtd_preenchidos}/${r.qtd_itens}`,
                align: "center",
                sortValue: (r) => (r.qtd_itens ? r.qtd_preenchidos / r.qtd_itens : 0),
            },
            {
                id: "conformidade",
                header: "CONFORMIDADE",
                accessor: (r) => r.percent,
                align: "center",
                sortValue: (r) => r.percent,
                render: (v) => (
                    <span style={{ color: conformidadeColor(Number(v)) }}>
                        {Number(v).toFixed(2)}%
                    </span>
                ),
            },
            {
                id: "pdf",
                header: "",
                accessor: () => null,
                sortable: false,
                width: "52px",
                align: "center",
                render: (_v, row) => (
                    <IconeContainer>
                        {loadingIds.includes(row.id) ? (
                            <IconeLoad size={25} />
                        ) : (
                            <IconePDF
                                size={25}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleClick(row.id);
                                }}
                            />
                        )}
                    </IconeContainer>
                ),
            },
            ...(canDeleteChecklist
                ? [{
                    id: "delete",
                    header: "",
                    accessor: () => null,
                    sortable: false,
                    width: "52px",
                    align: "center",
                    render: (_v, row) => (
                        <IconeContainer>
                            <IconeLixeira
                                size={22}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setChecklistDelete(row);
                                }}
                            />
                        </IconeContainer>
                    ),
                }]
                : []),
        ],
        [loadingIds, handleClick, canDeleteChecklist]
    );

    const openMyMetas = () => {

        closeModal();
        navigate('./minhas-metas');

    }

    const filterFields = (
        <>
            <FilterContainer
                type="select"
                placeholder="TIPO..."
                options={listaTipos}
                optType={'obj'}
                valor={tipoFiltered}
                changeFunc={(value) => setTipoFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="MODELO..."
                options={listaModelos}
                optType={'obj'}
                valor={modeloFiltered}
                changeFunc={(value) => setModeloFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="EQUIPAMENTO..."
                options={listaEquipamentos}
                optType={'obj'}
                valor={equipamentoFiltered}
                changeFunc={(value) => setEquipamentoFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="CENTRO CUSTO..."
                options={listaCC}
                optType={'obj'}
                valor={centroCustoFiltered}
                changeFunc={(value) => setCentroCustoFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="CONTRATO..."
                options={listaContrato}
                optType={'obj'}
                valor={contratoFiltered}
                changeFunc={(value) => setContratoFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="EQUIPE..."
                options={listaEquipes}
                optType={'obj'}
                valor={equipeFiltered}
                changeFunc={(value) => setEquipeFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="STATUS..."
                options={[
                    "EM ANDAMENTO",
                    "FINALIZADO"
                ]}
                optType={'obj'}
                valor={statusFiltered}
                changeFunc={(value) => setStatusFiltered(value)}
            />
            <FilterContainer
                type="select"
                placeholder="USUÁRIO..."
                options={listaUsuarios}
                optType={'obj'}
                valor={usuarioFiltered}
                changeFunc={(value) => setUsuarioFiltered(value)}
            />
            <FilterContainer
                type="date"
                valor={dataInicial}
                changeFunc={(value) => setDataInicial(value)}
            />
            <FilterContainer
                type="date"
                valor={dataFinal}
                changeFunc={(value) => setDataFinal(value)}
            />
        </>
    );

    return (
        <>
            <GenericHeader responsive>
                {!isMobile && (
                    <Filters columns={5} >
                        {filterFields}
                    </Filters>
                )}
                <StatsWrapper>
                    <Stats>
                        <ContainerStats>
                            <p>CONFORMIDADE: {totalPercent.toFixed(2)}%</p>
                            <p>NÃO CONFORMIDADE: {ncPercent.toFixed(2)}%</p>
                            <p>ITENS CONFORMES: {totalConformes}</p>
                            <p>ITENS NÃO CONFORMES: {totalNaoConformes}</p>
                            <p>ITENS PREENCHIDOS: {somaPreenchidos}/{somaTotalItens}</p>
                        </ContainerStats>
                    </Stats>
                </StatsWrapper>
            </GenericHeader>
            <TableArea>
                <SortableTable
                    ref={tabelaRef}
                    columns={columns}
                    data={checklistsFilter}
                    getRowId={(row) => row.identifier}
                    limit={linhas}
                    isLoading={loading}
                    loadingText="Carregando checklists..."
                    onRowClick={(row) => window.open(`/modulo/ssma/check-list/${row.identifier}`, "_blank", "noopener,noreferrer")}
                    rowCursor="pointer"
                    emptyText="NENHUM CHECKLIST ENCONTRADO"
                    initialSort={{ key: "data", direction: "desc" }}
                />
            </TableArea>
            {
                isModalOpen('sidebarChecklist') && (
                    <Overlay changeContent={closeSideBar} state={true} >
                        <SideMenu>
                            {VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'editar' }) && (
                                <SideMenuBtn
                                    button="CHECKLIST INFO"
                                    clickFunc={openChecklistTipos}
                                />
                            )}
                            {
                                VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'metas' }) && (
                                    <SideMenuBtn
                                        button="METAS"
                                        clickFunc={ openMetas }
                                    />
                                )
                            }
                            <SideMenuBtn
                                button="MINHAS METAS"
                                clickFunc={ openMyMetas }
                            />
                            {VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'view-nc' }) && (
                                <SideMenuBtn
                                    button="NÃO CONFORMIDADES"
                                    clickFunc={openNaoConformidades}
                                />
                            )}
                            <SideMenuBtn
                                button="NOVO CHECKLIST"
                                clickFunc={openNewChecklist}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen('addChecklistModal') && (
                    <ModalAddChecklist
                        fetchSuccess={fetchChecklist}
                    />
                )
            }
            {
                isModalOpen('tiposCheckListModal') && (
                    <ModalChecklistTipos />
                )
            }
            {
                isMobile && isModalOpen('checklistFiltersMobile') && (
                    <Overlay state={true} >
                        <Modal header close={closeModal} size="md" >
                            <MobileFiltersStack>
                                {filterFields}
                            </MobileFiltersStack>
                        </Modal>
                    </Overlay>
                )
            }
            {
                checklistDelete && canDeleteChecklist && (
                    <ModalDeleteChecklist
                        checklist={checklistDelete}
                        fecharModal={() => setChecklistDelete(null)}
                        fetchSuccess={fetchChecklist}
                    />
                )
            }
        </>
    )
}

export default Content;